import { API_BASE_URL } from '@/lib/api';

export const PUBLIC_FEATURE_FLAGS_QUERY_KEY = ['public-feature-flags'] as const;

export type PublicFeatureFlags = {
  flags: {
    divorce?: boolean;
  };
};

export async function fetchPublicFeatureFlags(): Promise<PublicFeatureFlags> {
  try {
    const res = await fetch(`${API_BASE_URL}/v1/public/feature-flags`);
    if (!res.ok) return { flags: {} };
    const body = (await res.json()) as PublicFeatureFlags;
    return body?.flags ? body : { flags: {} };
  } catch {
    return { flags: {} };
  }
}

export function isDivorceProductEnabled(
  data: PublicFeatureFlags | undefined,
): boolean {
  return data?.flags?.divorce === true;
}
